<template>
  <v-content>
    <v-container style="min-height: 100%">
      <v-layout
        column class="text-xs-center"
        justify-center style="min-height: 80vh"
      >
        <h1 class="display-1">Not Found.</h1>
        <v-img
          src="/img/leapyfrog.png"
          height="50" contain
          class="my-3"
        />
        <p class="title grey--text">
          Looks like whatever you're looking for doesn't exist here.
        </p>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
// Mixins
import { managedDocumentAttributes } from '@/mixins/managedDocumentAttributes.js'

export default {
  mixins: [managedDocumentAttributes],

  created() {
    this.documentAttributes.title = 'Nope. - Leaply'
  },
}
</script>
